import { render } from "./AutologinPage.vue?vue&type=template&id=61eeb574"
import script from "./AutologinPage.vue?vue&type=script&lang=js"
export * from "./AutologinPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__